module.exports = __webpack_public_path__ + "img/zyl.d84d1489.png";